import axios from '../../plugins/axios';

/**
 * ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½Ð° ÑÐµÑÐ²ÐµÑ.
 *
 * @param {Object} params
 * @param {File} params.file - Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°
 * @param {number|string} params.carId - ID Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ
 * @param {string} params.name - ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°
 * @param {number} params.typeId - Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° (ID)
 * @returns {Promise<Object>} 
 */
export async function uploadCarDocument({ file, carId, name, typeId }) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('carId', carId);
  formData.append('name', name);
  formData.append('typeId', typeId);
  const response = await axios.post('/crm/cars/uploadDocument', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  });
  return response.data;
} 